import { OrderResponse, OrderResponseItem } from '../../data/models'
import { StatusTag } from './StatusTag'

export const StatusBodyTemplate = (
  confirmationCode:
    | OrderResponse['ConfirmationCode']
    | OrderResponseItem['ConfirmationCode'],
) => {
  if (!confirmationCode) return null

  return <StatusTag status={confirmationCode} />
}
